import { Col, Row } from "antd";
import {
  DropDown,
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../../components";
import styles from "./SeatingTable.module.css";
import { Table1, Table2, Table3, Table4, Table5 } from "./Tables";
import { cloneElement, useEffect, useState } from "react";
import Dropdown from "../../../../../../components/dropdowns/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../../../Store/Middlewares/EventPlanningMiddleware";
import { useLocation } from "react-router-dom";
import { showAlert } from "../../../../../../Store/Actions/GeneralActions";

export const people = [
  { name: "Frances Swann", relation: "Father" },
  { name: "Chris Glasser", relation: "Stacy's Friend" },
  { name: "Iva Ryan", relation: "Stacy's Friend" },
  { name: "Kathy Pacheco", relation: "Bridesmaid" },
  { name: "James Hall", relation: "Stacy's Friend" },
  { name: "Kenneth Allen", relation: "Stacy's Friend" },
];

export const tables = [
  { name: "Corner Table North", seats: 18, assigned: 15, vacant: 3 },
  { name: "Corner Table South", seats: 35, assigned: 35, vacant: 0 },
  { name: "Head Table", seats: 14, assigned: 11, vacant: 3 },
  { name: "Table 1", seats: 18, assigned: 15, vacant: 3 },
  { name: "Table 2", seats: 18, assigned: 15, vacant: 3 },
];

const tableTypes = [
  {
    id: 1,
    name: "round",
    component: <Table1 />,
  },
  {
    id: 2,
    name: "reactangle",
    component: <Table2 />,
  },
  {
    id: 3,
    name: "oval",
    component: <Table3 />,
  },
  {
    id: 4,
    name: "hexagon",
    component: <Table4 />,
  },
  {
    id: 5,
    name: "square",
    component: <Table5 />,
  },
];

const newTableObj = { name: "", seats: "", group: "" };

export const TableModal = ({ setAllTables, setModalOpen }) => {
  const [selectedType, setSelectedType] = useState(tableTypes[0].name);
  const [newTable, setNewTable] = useState(newTableObj);

  const dispatch = useDispatch();

  const { state } = useLocation();

  const Group = useSelector((state) => state.EventPlanningReducer.GuestGroup);
  // useEffect(() => {
  //   dispatch(
  //     EventPlanningMiddleware.guestGroups({
  //       name: "",
  //       event_id: state?.eventData?.id,
  //     })
  //   );
  // }, []);

  const handleChange = (value, key) => {
    setNewTable((prev) => ({ ...prev, [key]: value }));
  };

  // const addTable = () => {
  //   // setAllTables((prev) => [
  //   //   ...prev,
  //   //   { ...newTable, assigned: 0, vacant: newTable.seats },
  //   // ]);

  //   console.log(newTable);
  //   // setModalOpen(false);
  // };

  const createTable = () => {
    if (
      !newTable?.name ||
      !newTable?.group?.id ||
      !newTable?.seats ||
      !selectedType
    ) {
      dispatch(
        showAlert({
          type: "error",
          message: "Please add all required information!",
        })
      );
      // seterror("Please add all required information!");
    } else if (Math.sign(newTable?.seats) != 1 || newTable?.seats <= 0) {
      dispatch(
        showAlert({ type: "error", message: "Please enter valid no. of seats" })
      );
    } else if (newTable?.seats < newTable?.group?.total_members) {
      dispatch(
        showAlert({
          type: "error",
          message: "No. of seats are less than selected group members!",
        })
      );
    } else {
      // setsubmit(true);
      dispatch(
        EventPlanningMiddleware.createEventTable({
          event_id: state?.eventData?.id,
          guest_group_id: newTable?.group?.id,
          name: newTable?.name,
          seats: newTable?.seats,
          type: selectedType,
        })
      )
        .then(() => {
          setModalOpen(false);
        })
        .catch((data) => {
          setModalOpen(false);
        });
    }
  };

  return (
    <>
      <Row className={styles.venueModalTitleRow}>
        <TextComponent textClass={styles.venueModalTitle}>
          Add Table
        </TextComponent>
      </Row>
      <Row>
        <TextComponent>
          Add some tables to get started. You can add guests to your table later
        </TextComponent>
      </Row>
      <Row className={styles.venueModalTypesRow}>
        <TextComponent>Types of Table</TextComponent>
      </Row>
      <Row style={{ justifyContent: "space-between" }}>
        {tableTypes?.map((table) => {
          return (
            <Col
              key={table.id}
              className={styles.tableTypeCol}
              onClick={() => setSelectedType(table.name)}
            >
              {cloneElement(table.component, {
                selectedValue: table.name === selectedType,
              })}
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col xs={24}>
          <InputField
            label="Table Name"
            placeholder="Head Table"
            value={newTable.name}
            onChange={(e) => handleChange(e.target.value, "name")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Dropdown
            label="Group"
            placeholder="Select Group"
            object={Group}
            onChange={(val) => handleChange(val, "group")}
          />
          <InputField
            label="Seats"
            type="number"
            placeholder="Seats"
            value={newTable.seats}
            onChange={(e) => handleChange(e.target.value, "seats")}
          />
        </Col>
      </Row>
      <Row className={styles.btnRow}>
        <Col xs={24}>
          <SubmitButton title="Save Table" onClick={createTable} />
        </Col>
      </Row>
    </>
  );
};
